export default "__VITE_ASSET__1al0qSam__"